import { URI } from '@/config/config';

export default async ({ rootState }, { userToken }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };
  const path = new URL(
    `${URI}control-panel/consumer/verify-wallet/${userToken}`,
  );

  const response = await fetch(path, opts);
  const jsonResult = await response.json();
  if (response.status >= 400) {
    return Promise.reject(jsonResult);
  }

  return jsonResult;
};
